import { Image } from '@ks89/angular-modal-gallery';
import { ItinerarioStop } from './itinerario-stop';

export class Itinerario {
  id: string;
  title?: string;
  typeElement?: {
    key?: string;
    label?: string;
  };
  categories?: Array<{
    key?: string;
    label?: string;
  }>;
  period?: string;
  shortDescription?: string;
  extendedDescription?: string;
  image?: string;
  captionImage?: String;
  thumbnail?: string;
  lengthKm?: number;
  durationHours?: number;
  breakAreas?: boolean;
  flooring?: string;
  dressRecommended?: string;
  creationDate?: Date;
  lastUpdate?: Date;
  stops?: Array<ItinerarioStop>;
  telephone?: string;
  webSite?: string;
  email?: string;
  userPreferred?: number;
  isFavourite: boolean;

  gallery?: any;
  galleryImages?: Image[];
}
